import React from 'react';
import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuItem,
} from './ui/dropdown-menu';

export const SimpleLanguageSelector = () => {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'en', name: 'English', shortName: 'EN', flag: '🇺🇸' },
    { code: 'bg', name: 'Български', shortName: 'БГ', flag: '🇧🇬' }
    // Italian hidden for Bulgarian market launch
    // { code: 'it', name: 'Italiano', shortName: 'IT', flag: '🇮🇹' }
  ];

  const currentLang = languages.find(l => l.code === i18n.language) || languages[0];

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="sm" 
          className="flex items-center gap-1.5 px-1.5 sm:px-3 py-1.5 hover:bg-gray-100 rounded-lg border border-gray-200 text-gray-700"
          data-testid="language-selector-trigger"
        >
          <span className="text-lg leading-none">{currentLang.flag}</span>
          <span className="hidden sm:inline text-sm font-medium">{currentLang.name}</span>
        </Button>
      </DropdownMenuTrigger>
      
      <DropdownMenuContent align="end" className="w-48 p-1 shadow-lg border border-gray-200">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            className={`flex items-center justify-between gap-3 px-3 py-2.5 cursor-pointer rounded-md transition-colors ${
              i18n.language === lang.code 
                ? 'bg-blue-50 text-blue-700' 
                : 'hover:bg-gray-50'
            }`}
            data-testid={`language-option-${lang.code}`}
          >
            <div className="flex items-center gap-3">
              <span className="text-xl">{lang.flag}</span>
              <span className="font-medium">{lang.name}</span>
            </div>
            {i18n.language === lang.code && (
              <Check className="w-4 h-4 text-blue-600" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
